import { mockedData } from '../mockedData';
import { WorkflowState } from './workflow-state.model';

export const workflowMockedData = {
  crewMemberId: mockedData.crewMemberId,
  docType: 'PRECHECK_WORKFLOW_STATES',
  shipCode: mockedData.shipCode,
  signonDate: mockedData.signOnDate,
  healthCheckStatus: 0,
  hrStatus: 0,
  debarkStatus: 0,
  medicalStatus: 0,
  precheckStatus: 0,
  safetyStatus: 0,
  immigrationStatus: 0,
};

export const workflowStateMock = new WorkflowState(workflowMockedData);

export const onProgressWorkflowStateMock = new WorkflowState({ ...workflowMockedData, precheckStatus: 75 });
